/**
 * Info describing a person.
 */
export interface PersonalInfo {
  readonly firstName: string
  /**
   * The person's middle initial, if any.
   */
  readonly middleInitial: string | null
  readonly lastName: string
  /**
   * The person's DOB, in the local time zone.
   */
  readonly dateOfBirth: Date | null
  /**
   * SSN or ITIN.
   */
  readonly personalTaxpayerIdentificationNumber: string
}

export const PersonalInfo = {
  /**
   * Empty personal info.
   */
  empty: {
    firstName: '',
    middleInitial: null,
    lastName: '',
    dateOfBirth: null,
    personalTaxpayerIdentificationNumber: '',
  } satisfies PersonalInfo,
}
